import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { useOrg } from '../OrgProvider';
import { navigateTo } from '../router';

export function CreateOrgPage() {
  const { createOrg } = useOrg();
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  function handleNameChange(value: string) {
    setName(value);
    // Auto-generate slug from name
    setSlug(
      value
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '')
    );
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim() || !slug.trim()) return;
    setSubmitting(true);
    setError(null);
    try {
      await createOrg(name.trim(), slug.trim());
      navigateTo('/org/settings');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create organization');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="mx-auto max-w-md py-8">
      <h1 className="text-lg font-semibold text-ink">Create Organization</h1>
      <p className="mt-1 text-sm text-dim">
        Organizations let you manage packages, API keys, and team members.
      </p>

      <form onSubmit={(e) => void handleSubmit(e)} className="mt-6 space-y-4">
        <div>
          <label htmlFor="org-name" className="block text-sm font-medium text-ink">
            Name
          </label>
          <input
            id="org-name"
            type="text"
            value={name}
            onChange={(e) => handleNameChange(e.target.value)}
            placeholder="My Organization"
            className="lc-input mt-1"
            required
          />
        </div>

        <div>
          <label htmlFor="org-slug" className="block text-sm font-medium text-ink">
            Slug
          </label>
          <input
            id="org-slug"
            type="text"
            value={slug}
            onChange={(e) => setSlug(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))}
            placeholder="my-organization"
            pattern="[a-z0-9-]+"
            className="lc-input mt-1 font-mono"
            required
          />
          <p className="mt-1 text-xs text-dim">Lowercase letters, numbers, and hyphens only.</p>
        </div>

        {error && <p className="text-sm text-del">{error}</p>}

        <div className="flex gap-2">
          <Button type="submit" disabled={submitting || !name.trim() || !slug.trim()}>
            {submitting ? 'Creating…' : 'Create'}
          </Button>
          <Button variant="secondary" type="button" onClick={() => navigateTo('/')}>
            Cancel
          </Button>
        </div>
      </form>
    </div>
  );
}
